var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal2",
    {
      attrs: {
        design: "v3",
        "show-footer": true,
        "show-title": true,
        title: "WhatsApp Liste Mesajı Ayarları",
        "ok-text": "Kaydet",
        "cancel-text": "İptal",
        "class-name": "whatsapp-settings-modal",
      },
      on: { ok: _vm.handleSave, cancel: _vm.handleCancel },
    },
    [
      _c("div", { staticClass: "whatsapp-settings-form" }, [
        _c("div", { staticClass: "info-banner" }, [
          _c("span", { staticClass: "material-icons" }, [_vm._v("info")]),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              "3'ten fazla buton olduğunda WhatsApp liste mesajı olarak gönderilir. Bu ayarları\n                özelleştirebilirsiniz."
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "setting-field" }, [
          _c(
            "div",
            { staticClass: "field-header" },
            [
              _c("label", [_vm._v("Liste Buton Başlığı")]),
              _vm._v(" "),
              _c(
                "a-tooltip",
                {
                  attrs: { placement: "topRight" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "tooltip-content" }, [
                            _c("p", [
                              _vm._v(
                                "Kullanıcının listeyi açmak için tıklayacağı buton metni"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "limit-info" }, [
                              _vm._v("Maksimum: 20 karakter"),
                            ]),
                            _vm._v(" "),
                            _c("img", {
                              attrs: {
                                src: "https://static.supsis.live/common/whatsapp/waba-list-button-min.png",
                                alt: "Global Button",
                              },
                            }),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _vm._v(" "),
                  _c("span", { staticClass: "material-icons help-icon" }, [
                    _vm._v("help_outline"),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.localSettings.globalButtonTitle,
                expression: "localSettings.globalButtonTitle",
              },
            ],
            staticClass: "settings-input",
            attrs: { type: "text", placeholder: "Seçenekler", maxlength: "20" },
            domProps: { value: _vm.localSettings.globalButtonTitle },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.localSettings,
                  "globalButtonTitle",
                  $event.target.value
                )
              },
            },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "char-count" }, [
            _vm._v(
              _vm._s((_vm.localSettings.globalButtonTitle || "").length) + "/20"
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "setting-field" }, [
          _c(
            "div",
            { staticClass: "field-header" },
            [
              _c("label", [_vm._v("Bölüm Başlığı")]),
              _vm._v(" "),
              _c(
                "a-tooltip",
                {
                  attrs: { placement: "topRight" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "tooltip-content" }, [
                            _c("p", [_vm._v("Liste içindeki bölüm başlığı")]),
                            _vm._v(" "),
                            _c("p", { staticClass: "limit-info" }, [
                              _vm._v("Maksimum: 24 karakter"),
                            ]),
                            _vm._v(" "),
                            _c("img", {
                              attrs: {
                                src: "https://static.supsis.live/common/whatsapp/waba-list-button-min.png",
                                alt: "Section Title",
                              },
                            }),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _vm._v(" "),
                  _c("span", { staticClass: "material-icons help-icon" }, [
                    _vm._v("help_outline"),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.localSettings.sectionTitle,
                expression: "localSettings.sectionTitle",
              },
            ],
            staticClass: "settings-input",
            attrs: {
              type: "text",
              placeholder: "Seçim yapınız",
              maxlength: "24",
            },
            domProps: { value: _vm.localSettings.sectionTitle },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.localSettings, "sectionTitle", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "char-count" }, [
            _vm._v(
              _vm._s((_vm.localSettings.sectionTitle || "").length) + "/24"
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "setting-field" }, [
          _c(
            "div",
            { staticClass: "field-header" },
            [
              _c("label", [_vm._v("Bölüm Açıklaması")]),
              _vm._v(" "),
              _c(
                "a-tooltip",
                {
                  attrs: { placement: "topRight" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "tooltip-content" }, [
                            _c("p", [
                              _vm._v("Liste bölümü için açıklama metni"),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "limit-info" }, [
                              _vm._v("Maksimum: 72 karakter"),
                            ]),
                            _vm._v(" "),
                            _c("img", {
                              attrs: {
                                src: "https://static.supsis.live/common/whatsapp/waba-list-button-min.png",
                                alt: "Section Subtitle",
                              },
                            }),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _vm._v(" "),
                  _c("span", { staticClass: "material-icons help-icon" }, [
                    _vm._v("help_outline"),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.localSettings.sectionSubTitle,
                expression: "localSettings.sectionSubTitle",
              },
            ],
            staticClass: "settings-input",
            attrs: {
              type: "text",
              placeholder: "Aşağıdaki seçeneklerden birini seçiniz",
              maxlength: "72",
            },
            domProps: { value: _vm.localSettings.sectionSubTitle },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.localSettings,
                  "sectionSubTitle",
                  $event.target.value
                )
              },
            },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "char-count" }, [
            _vm._v(
              _vm._s((_vm.localSettings.sectionSubTitle || "").length) + "/72"
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "setting-field" }, [
          _c(
            "div",
            { staticClass: "field-header" },
            [
              _c("label", [_vm._v("Alt Bilgi (Footer)")]),
              _vm._v(" "),
              _c(
                "a-tooltip",
                {
                  attrs: { placement: "topRight" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "tooltip-content" }, [
                            _c("p", [
                              _vm._v(
                                "Mesajın altında görünecek isteğe bağlı metin"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "limit-info" }, [
                              _vm._v("Maksimum: 60 karakter"),
                            ]),
                            _vm._v(" "),
                            _c("img", {
                              attrs: {
                                src: "https://static.supsis.live/common/whatsapp/waba-list-button-min.png",
                                alt: "Footer",
                              },
                            }),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _vm._v(" "),
                  _c("span", { staticClass: "material-icons help-icon" }, [
                    _vm._v("help_outline"),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.localSettings.footer,
                expression: "localSettings.footer",
              },
            ],
            staticClass: "settings-input",
            attrs: {
              type: "text",
              placeholder: "İsteğe bağlı alt bilgi",
              maxlength: "60",
            },
            domProps: { value: _vm.localSettings.footer },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.localSettings, "footer", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "char-count" }, [
            _vm._v(_vm._s((_vm.localSettings.footer || "").length) + "/60"),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }